<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><g transform="translate(1 1)"><path d="M755,454.671a8.983,8.983,0,0,0,.56,3.13l8.44.783,8.44-.783a9.032,9.032,0,0,0,0-6.261l-8.44-.783-8.44.783a8.984,8.984,0,0,0-.56,3.13Zm0,0" transform="translate(-755 -445.671)" fill="#ffda44"/><path d="M784.618,340.87a9,9,0,0,0-16.88,0Zm0,0" transform="translate(-767.178 -335)" fill="#d80027"/><path d="M767.738,611.035a9,9,0,0,0,16.88,0Zm0,0" transform="translate(-767.178 -598.905)" fill="#d80027"/><g fill="none" stroke="#e4e4e4" stroke-width="1"><circle cx="9" cy="9" r="9" stroke="none"/><circle cx="9" cy="9" r="9.5" fill="none"/></g></g></svg>
</template>

<script>
  export default {
    name: 'es-ES',
  };
</script>
